import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import CustomeModal from "../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteBookingTemplate,
  getAllBookingByCompanyId,
} from "../../redux/actions/bookingtemplate";
import {
  SET_TEMPLATE_HEADER_NAME,
  GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID,
} from "../../redux/constants";
import Table, { TableRow } from "../../component/table";
import Loader from "react-spinner-loader";
import useDebounce from "../../Hook/useDebounce";
import RowsPerPageSelector from "../../component/RowsPerPageSelector";
import PageSelector from "../../component/PageSelector";

function BookingTemplateOverviewTable({ searchText }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { bookingTemplateList } = useSelector((state) => state.bookingTemplate);
  const { row_count } = useSelector((state) => state.auth);

  // Creating state for datatable
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState();
  const [loader, setLoader] = useState(false);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const _handleDelete = (booking_template_id) => {
    dispatch(
      deleteBookingTemplate(booking_template_id, (res) => {
        getTemplateData();
      })
    );
  };

  const getTemplateData = () => {
    setLoader(true);
    dispatch(
      getAllBookingByCompanyId(
        (res) => {
          setLoader(false);
        },
        debouncedHandleSearch,
        page,
        row_count,
        sortField,
        sortOrder
      )
    );
  };

  // Use the debounce hook to get the debounced version of the handleSearch function
  const debouncedHandleSearch = useDebounce(searchText, 300);

  useEffect(() => {
    getTemplateData();
  }, [debouncedHandleSearch, page, row_count, sortField, sortOrder]);

  useEffect(() => {
    if (sort) {
      setPage(1);
      setSortField(sort.headName);
      setSortOrder(sort.type);
    }
  }, [sort]);

  const TemplateTable = ({
    index,
    templateItem,
    booking_template_name,
    name,
    createdAt,
  }) => {
    return (
      <TableRow
        key={index}
        row={{ booking_template_name, name, createdAt }}
        tdClass="px-2 py-2 text-sm leading-4 tracking-tight first:pl-4 text-[#1E293B] text-center first:text-left bg-[--bg-color-50] first:rounded-l-md last:rounded-r-md max-w-1/4 truncate"
      >
        <td className="px-2 py-2 whitespace-nowrap text-center text-sm bg-[--bg-color-50] rounded-r-md leading-4 tracking-tight text-[--bg-color-500] font-semibold">
          <div className="space-x-3 flex items-center justify-center">
            <div title="Edit">
              <span
                className="fa-light fa-pen text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={() => {
                  dispatch({
                    type: SET_TEMPLATE_HEADER_NAME,
                    payload: templateItem.booking_template_name,
                  });
                  const bookingpropsid = templateItem.booking_template_id;
                  navigate("/booking/design/update", {
                    state: bookingpropsid,
                  });
                }}
              ></span>
            </div>
            <div title="Delete">
              <span
                className="fa-light fa-trash-can text-base cursor-pointer"
                style={{ color: "#eb5757" }}
                onClick={() => {
                  swal({
                    content: (
                      <CustomeModal
                        type="delete"
                        title="Are you sure?"
                        content={`All of your data will be permanently removed from our servers forever. This action cannot be undone.`}
                        onDelete={() =>
                          _handleDelete(templateItem.booking_template_id)
                        }
                      />
                    ),
                    buttons: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                  });
                }}
              ></span>
            </div>
          </div>
        </td>
      </TableRow>
    );
  };
  return (
    <div className="space-y-1">
      <Table
        heads={[
          {
            headName: "Booking Template",
            isSort: true,
            value: "booking_template_name",
          },
          { headName: "Created By", isSort: true, value: "name" },
          { headName: "Created At", isSort: true, value: "createdAt" },
          { headName: "Action", isSort: false, value: "Action" },
        ]}
        tClass="table-fixed w-full border-separate border-spacing-y-2"
        hClass="text-sm leading-2 tracking-tight font-semibold text-[#1E293B] bg-[--bg-color-50]"
        bClass="text-sm"
        thClass={`px-2 py-3 whitespace-nowrap first:text-left text-center font-semibold first:pl-4 first:rounded-l-md last:rounded-r-md max-w-1/4`}
        setSort={setSort}
        sort={sort}
      >
        {loader ? (
          <tr className="px-2 py-3 whitespace-nowrap">
            <td colSpan={4}>
              <div className="flex justify-center p-2 my-2 whitespace-nowrap w-full">
                <Loader show={loader} />
              </div>
            </td>
          </tr>
        ) : bookingTemplateList?.data?.length > 0 ? (
          bookingTemplateList.data.map((templateItem, index) => {
            const { booking_template_name, name } = templateItem;
            const createdAt = moment(templateItem.createdAt).format(
              "DD MMM, YYYY - HH:mm a"
            );
            return (
              <TemplateTable
                index={index}
                templateItem={templateItem}
                booking_template_name={booking_template_name}
                name={name}
                createdAt={createdAt}
              />
            );
          })
        ) : (
          <td
            colSpan={4}
            className="text-center py-2 text-lg text-[#1E293B] tracking-tight leading-4"
          >
            There are no records to display
          </td>
        )}
      </Table>
      {!loader && bookingTemplateList?.data?.length > 0 && (
        <div className="flex justify-between items-center">
          <RowsPerPageSelector />
          <PageSelector
            rowPerPage={row_count}
            page={page}
            setpage={(newPage) => {
              setPage(newPage);
            }}
            totalDataCount={
              bookingTemplateList ? bookingTemplateList.totalCount : 0
            }
          />
        </div>
      )}
    </div>
  );
}
export default BookingTemplateOverviewTable;
